/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Admin_Stdayago2Inputs */

const zh_landing_admin_stdayago2 = /** @type {(inputs: Landing_Admin_Stdayago2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 天前`)
};

const en_landing_admin_stdayago2 = /** @type {(inputs: Landing_Admin_Stdayago2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 day ago`)
};

const es_landing_admin_stdayago2 = /** @type {(inputs: Landing_Admin_Stdayago2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hace 1 día`)
};

/**
* | output |
* | --- |
* | "1 day ago" |
*
* @param {Landing_Admin_Stdayago2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_admin_stdayago2 = /** @type {((inputs?: Landing_Admin_Stdayago2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Admin_Stdayago2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_admin_stdayago2(inputs)
	if (locale === "en") return en_landing_admin_stdayago2(inputs)
	return es_landing_admin_stdayago2(inputs)
});
export { landing_admin_stdayago2 as "landing_admin_stDayAgo" }